/** @file Camera store: viewport pan and zoom (CameraSlice); the viewport reads it outside React. */
import { createStore } from 'zustand/vanilla';
import type { CameraSlice } from './types';

/** Origin-centred at 100 %. */
export const cameraStore = createStore<CameraSlice>()(() => ({ x: 0, y: 0, zoom: 1 }));
